import React, { useState, useEffect } from 'react';
import QRCode from 'qrcode';
import { LABEL_TEMPLATES } from '../../utils/printUtils';

/**
 * Store Label Component (ใบปะหน้าของร้านค้า)
 * สำหรับพิมพ์หรือ share ไป LINE
 */
const StoreLabel = ({ 
  store, 
  templateType = 'a4' 
}) => {
  const [qrCodeUrl, setQrCodeUrl] = useState(null);

  // Generate QR Code สำหรับข้อมูลร้าน (URL หรือข้อมูลติดต่อ)
  useEffect(() => {
    const generateQRCode = async () => {
      if (!store) return;
      
      try {
        // สร้าง QR Code ที่มีข้อมูลร้าน
        const storeData = {
          name: store.name,
          phone: store.contact?.phone || '',
          email: store.contact?.email || '',
          lineId: store.contact?.lineId || '',
          address: store.contact?.address || ''
        };
        
        // ถ้ามี LINE ID ให้สร้าง QR Code สำหรับ LINE
        if (store.contact?.lineId) {
          const qrData = `https://line.me/R/ti/p/${store.contact.lineId}`;
          const qrCodeDataURL = await QRCode.toDataURL(qrData, {
            width: 300,
            margin: 2,
            color: {
              dark: '#000000',
              light: '#FFFFFF'
            }
          });
          setQrCodeUrl(qrCodeDataURL);
        } else if (store.contact?.phone) {
          // ถ้าไม่มี LINE ID แต่มีเบอร์โทร ให้ใช้ tel:
          const qrData = `tel:${store.contact.phone}`;
          const qrCodeDataURL = await QRCode.toDataURL(qrData, {
            width: 300,
            margin: 2,
            color: {
              dark: '#000000',
              light: '#FFFFFF'
            }
          });
          setQrCodeUrl(qrCodeDataURL);
        } else {
          // ใช้ข้อมูลร้านเป็น JSON
          const qrData = JSON.stringify(storeData);
          const qrCodeDataURL = await QRCode.toDataURL(qrData, {
            width: 300,
            margin: 2,
            color: {
              dark: '#000000',
              light: '#FFFFFF'
            }
          });
          setQrCodeUrl(qrCodeDataURL);
        }
      } catch (error) {
        console.error('Error generating QR code:', error);
      }
    };

    generateQRCode();
  }, [store]);

  const template = LABEL_TEMPLATES[templateType.toUpperCase()] || LABEL_TEMPLATES.A4;

  return (
    <div 
      id="store-label-print"
      className="print-content"
      style={{
        width: template.width,
        minHeight: template.height,
        margin: '0 auto',
        padding: '2cm',
        fontFamily: "'Sarabun', 'Kanit', Arial, sans-serif",
        backgroundColor: 'white',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center'
      }}
    >
      {/* Logo */}
      {store?.logo && (
        <div className="mb-6">
          <img 
            src={store.logo} 
            alt={store.name}
            style={{ 
              maxHeight: '120px', 
              maxWidth: '300px',
              objectFit: 'contain'
            }}
          />
        </div>
      )}

      {/* Store Name */}
      <h1 className="text-3xl font-bold text-gray-800 mb-4">
        {store?.name || 'ร้านค้า'}
      </h1>

      {/* Description */}
      {store?.description && (
        <p className="text-sm text-gray-600 mb-6 max-w-2xl">
          {store.description}
        </p>
      )}

      {/* Contact Info */}
      <div className="mb-6 space-y-2 text-sm text-gray-700">
        {store?.contact?.address && (
          <div className="flex items-center justify-center gap-2">
            <span>📍</span>
            <span>{store.contact.address}</span>
          </div>
        )}
        {store?.contact?.phone && (
          <div className="flex items-center justify-center gap-2">
            <span>📞</span>
            <span>{store.contact.phone}</span>
          </div>
        )}
        {store?.contact?.email && (
          <div className="flex items-center justify-center gap-2">
            <span>📧</span>
            <span>{store.contact.email}</span>
          </div>
        )}
        {store?.contact?.lineId && (
          <div className="flex items-center justify-center gap-2">
            <span>💬</span>
            <span>LINE: {store.contact.lineId}</span>
          </div>
        )}
      </div>

      {/* QR Code */}
      {qrCodeUrl && (
        <div className="mb-6">
          <div className="text-sm font-semibold text-gray-700 mb-2">
            {store?.contact?.lineId ? '📱 Scan เพื่อเพิ่ม LINE' : '📱 Scan เพื่อติดต่อ'}
          </div>
          <img 
            src={qrCodeUrl} 
            alt="Store QR Code"
            style={{ 
              width: '200px', 
              height: '200px',
              margin: '0 auto',
              border: '3px solid #000',
              borderRadius: '8px'
            }}
          />
          {store?.contact?.lineId && (
            <div className="text-xs text-gray-600 mt-2">
              LINE ID: {store.contact.lineId}
            </div>
          )}
        </div>
      )}

      {/* Category */}
      {store?.category && (
        <div className="mb-6">
          <span className="inline-block px-4 py-2 bg-green-100 text-green-800 rounded-full text-sm font-semibold">
            {store.category}
          </span>
        </div>
      )}

      {/* Footer */}
      <div className="mt-6 pt-4 border-t border-gray-300 text-center text-xs text-gray-500">
        <div>พิมพ์เมื่อ: {new Date().toLocaleDateString('th-TH')}</div>
      </div>
    </div>
  );
};

export default StoreLabel;









